module.exports = __webpack_public_path__ + "img/iso-combles-perdus.1a012f9e.svg";